import React from 'react'
import {render} from "react-dom"

import App from 'currentTheme/App'

import {BrowserRouter as Router, Switch} from "react-router-dom"

// Polyfill
import Promise from 'promise-polyfill'
if (!window.Promise) {
   window.Promise = Promise;
}

render(
    <Router><App/></Router>,
   document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js